/*  MUI  */
import { DeleteOutlined } from '@mui/icons-material';
import { IconButton, TableCell } from '@mui/material';

/*  Shared  */
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';
import { DateFormat } from 'application/Shared/Components/Core';
import { ManagedTable } from 'application/Shared/Components/Table';
import { Notify } from 'application/Shared/Helpers';

/*  NPM  */
import axios from 'axios';
import i18n from 'i18n';

/*  Objects  */
import { Application } from 'objects/Application';
import {
    Breach,
    BreachDescription,
    BreachNistId,
    BreachResources,
    BreachScore
} from 'objects/Breach';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

const headers = [
    {
        align: 'left',
        field: 'dateAnnounced',
        renderHeader: <strong>{i18n.t('Common.date')}</strong>,
        width: '8%'
    },
    {
        align: 'left',
        field: 'name',
        renderHeader: <strong>{i18n.t('Common.application')}</strong>,
        width: '20%'
    },
    {
        align: 'left',
        field: 'description',
        renderHeader: <strong>{i18n.t('Common.description')}</strong>,
        width: '25%'
    },
    {
        align: 'left',
        field: 'severityScore',
        renderHeader: <strong>{i18n.t('Common.score')}</strong>,
        width: '7%'
    },
    {
        align: 'left',
        field: 'type',
        renderHeader: <strong>{i18n.t('VendorIncident.id')}</strong>,
        width: '18%'
    },
    {
        align: 'left',
        field: 'type',
        renderHeader: <strong>{i18n.t('Common.sources')}</strong>,
        width: '18%'
    },
    {
        align: 'right',
        field: null,
        renderHeader: <strong>{i18n.t('Common.actions')}</strong>,
        width: '10%'
    }
];

const parameters = { includeApplication: true, size: -1 };

const searchFields = ['description'];

const renderApplication = (application) => (
    <Application data={application} nameLinkTo="/globaladmin/application">
        <ApplicationNameLinkCell withCategory />
    </Application>
);

class List extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, rerender: false };
    }

    componentDidMount() {
        this.setState({ loaded: true });
    }

    deleteBreach = async (breachId) => {
        try {
            await axios.delete(`/breach/${breachId}`);
            Notify.s('Vendor Security Event deleted');
            this.rerender();
        } catch (e) {
            Notify.e('Failed to delete Vendor Security Event');
        }
    };

    rerender = async () => {
        this.setState({ rerender: true }, () => {
            this.setState({ rerender: false });
        });
    };

    renderRow = (row) => {
        const { id, application, dateAnnounced } = row;

        return (
            <Breach data={row}>
                <TableCell>
                    <DateFormat date={dateAnnounced} noTimeString />
                </TableCell>
                <TableCell>{renderApplication(application)}</TableCell>
                <TableCell>
                    <BreachDescription lines={10} includeSteps />
                </TableCell>
                <TableCell>
                    <BreachScore />
                </TableCell>
                <TableCell>
                    <BreachNistId lines={-1} />
                </TableCell>
                <TableCell>
                    <BreachResources noTitle />
                </TableCell>
                <TableCell>
                    <IconButton
                        data-trackid="globalAdmin_vendorIncidents_delete"
                        size="small"
                        color="secondary"
                        onClick={() => this.deleteBreach(id)}
                    >
                        <DeleteOutlined />
                    </IconButton>
                </TableCell>
            </Breach>
        );
    };

    render() {
        const { loaded, rerender } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <ManagedTable
                headers={headers}
                parameters={parameters}
                renderBody={this.renderRow}
                renderBodyKey="id"
                renderFooter
                rerender={rerender}
                rowHeight={42}
                rowsApi="/breach"
                rowsApiPreload
                rowsPerPage={10}
                searchEnabled
                searchFields={searchFields}
                sortDirection="DESC"
                sortFieldType="date"
                sortKey="dateAnnounced"
            />
        );
    }
}
export default withTranslation()(List);
